module.exports = __webpack_public_path__ + "img/order_concat_customer@2x.ad297e6e.png";